export const Block = {
    UNSTYLED: 'unstyled',
    PARAGRAPH: 'unstyled',
    OL: 'ordered-list-item',
    UL: 'unordered-list-item',
    H1: 'header-one',
    H2: 'header-two',
    H3: 'header-three',
    H4: 'header-four',
    H5: 'header-five',
    H6: 'header-six',
    CODE: 'code-block',
    BLOCKQUOTE: 'BLOCKQUOTE',
    PULLQUOTE: 'pullquote',
    ATOMIC: 'atomic',
    BLOCKQUOTE_CAPTION: 'block-quote-caption',
    CAPTION: 'caption',
    TODO: 'todo',
    IMAGE: 'IMAGE',
    BREAK: 'BREAK',
};

export const Inline = {
    BOLD: 'BOLD',
    CODE: 'CODE',
    ITALIC: 'ITALIC',
    STRIKETHROUGH: 'STRIKETHROUGH',
    UNDERLINE: 'UNDERLINE',
    HIGHLIGHT: 'HIGHLIGHT',
};

export const Entity = {
    LINK: 'LINK',
};